"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable class-methods-use-this */
const axios_1 = __importDefault(require("axios"));
const BaseBuyProvider_1 = require("../BaseBuyProvider");
const countries_1 = __importDefault(require("./countries"));
const cryptos_1 = __importDefault(require("./cryptos"));
const fiats_1 = __importDefault(require("./fiats"));
const transak_png_1 = __importDefault(require("../../../../static/providers/transak.png"));
const constants_1 = require("./constants");
const fiatRates_1 = require("../../helpers/fiatRates");
// import { convertFiatRate } from "../../helpers/fiatRates";
const TRANSAK_BASE_URL = process.env.DEPLOY_ENV === "production"
    ? constants_1.TRANSAK_API_URL_PROD
    : constants_1.TRANSAK_API_URL_STAGE;
/* const TRANSAK_API_KEY =
  process.env.DEPLOY_ENV === "production"
    ? TRANSAK_API_KEY_PROD
    : TRANSAK_API_KEY_STAGE; */
class TransakProvider {
    constructor() {
        this.id = "transak";
        this.name = "Transak";
        this.logo = transak_png_1.default;
        this.addressPassthrough = true;
        this.fiats = [];
        this.defaultFiatCurrency = "GBP";
    }
    getSupportedCountries() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data: { response }, } = yield axios_1.default.get(`${TRANSAK_BASE_URL}${constants_1.TRANSAK_API_ENDPOINTS.COUNTRIES}`);
                return response.reduce((p, c) => (c.isAllowed ? [...p, c.alpha2] : p), []);
            }
            catch (error) {
                console.log("Error getting Transak countries", error);
                return countries_1.default.reduce((p, c) => (c.isAllowed ? [...p, c.alpha2] : p), []);
            }
        });
    }
    getAvailability(countryData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!countryData)
                return false;
            const supportedCountries = yield this.getSupportedCountries();
            return supportedCountries.includes(countryData.alpha2.toUpperCase());
        });
    }
    getSupportedCryptos() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield axios_1.default.get(`${TRANSAK_BASE_URL}${constants_1.TRANSAK_API_ENDPOINTS.CRYPTOCURRENCIES}`);
                return data.response.map((c) => c.symbol);
            }
            catch (error) {
                return cryptos_1.default;
            }
        });
    }
    fetchFiats() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield axios_1.default.get(`${TRANSAK_BASE_URL}${constants_1.TRANSAK_API_ENDPOINTS.FIAT}`);
                this.fiats = data.response;
            }
            catch (error) {
                this.fiats = fiats_1.default;
            }
        });
    }
    getSupportedFiat() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.fiats.length === 0) {
                yield this.fetchFiats();
            }
            return this.fiats.map((fiat) => fiat.symbol);
        });
    }
    getPaymentMethods(fiatCode) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.fiats.length === 0) {
                yield this.fetchFiats();
            }
            const selectedFiat = this.fiats.find((i) => i.symbol === fiatCode);
            if (!selectedFiat)
                return [];
            const reducedPaymentOptions = selectedFiat.paymentOptions.reduce((prev, payment) => {
                const foundOption = constants_1.PAYMENT_OPTIONS.find((val) => val.id === payment.id);
                if (foundOption) {
                    return [...prev, foundOption];
                }
                return prev;
            }, []);
            return reducedPaymentOptions;
        });
    }
    getBuyQuote(cryptoCode, fiatCode, fiatAmount) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const paymentOptions = yield this.getPaymentMethods(fiatCode);
                const isRequestedCurrency = (yield this.getSupportedFiat()).includes(fiatCode);
                const currencyCode = isRequestedCurrency
                    ? fiatCode.toUpperCase()
                    : this.defaultFiatCurrency;
                const convertedRate = isRequestedCurrency
                    ? fiatAmount
                    : Math.ceil(yield (0, fiatRates_1.convertFiatRate)(currencyCode, fiatCode, fiatAmount));
                const responseData = {
                    cryptoAmount: -1,
                    fiatAmount: convertedRate,
                    provider: this.id,
                    rate: -1,
                    isRequestedCurrency,
                    paymentOptions,
                    fiatCode: currencyCode,
                };
                return responseData;
            }
            catch (error) {
                console.log("error getting transak quote", error);
                return BaseBuyProvider_1.DEFAULT_ERROR;
            }
        });
    }
}
exports.default = TransakProvider;
//# sourceMappingURL=Transak.js.map